// Is the object literal empty?
// https://stackoverflow.com/questions/2340509/javascript-trivia-check-for-equality-against-the-empty-object
export function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export function isUndefined(obj) {
    return typeof obj === "undefined";
}

// Access a nested object value by following a path of key values. For example:
// const obj = { a: { z: 'foo' }, b: 'bar'};
// `resolvePath(obj, 'a.z')`
// https://stackoverflow.com/a/43849204/19588
export const resolvePath = (object, path) => {
    const reducer = (o, pathSegment) => o ? o[pathSegment] : undefined;
    return path.split('.').reduce(reducer, object)
}
